import { ActionCreatorFactory, AsyncActionCreators } from 'typescript-fsa';
import { LeagueAssetsPayload, LeagueStatsPayload, Riot } from '../types';

export interface StatisticsActions {
  fetchLeagueOfLegendsStatsAC: AsyncActionCreators<LeagueStatsPayload, Riot.League.RawDataInfo, Error>;
  fetchLeagueOfLegendsCurrentVersionAC: AsyncActionCreators<void, string, Error>;
  fetchLeagueOfLegendsAssetsAC: AsyncActionCreators<LeagueAssetsPayload, Riot.League.Assets, Error>;
}

export function makeStatisticsActions(actionCreator: ActionCreatorFactory): StatisticsActions {
  const fetchLeagueOfLegendsStatsAC = actionCreator.async<LeagueStatsPayload, Riot.League.RawDataInfo, Error>('FETCH_LEAGUE_OF_LEGENDS_STATS');
  const fetchLeagueOfLegendsCurrentVersionAC = actionCreator.async<void, string, Error>('FETCH_LEAGUE_OF_LEGENDS_CURRENT_VERSION');
  const fetchLeagueOfLegendsAssetsAC = actionCreator.async<LeagueAssetsPayload, Riot.League.Assets, Error>('FETCH_LEAGUE_OF_LEGENDS_ASSETS');

  return {
    fetchLeagueOfLegendsStatsAC,
    fetchLeagueOfLegendsCurrentVersionAC,
    fetchLeagueOfLegendsAssetsAC,
  };
};
